module.exports = __webpack_public_path__ + "assets/img/face_contrast_example1.7bcb6cf0.jpeg";